/* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import Input from '@material-ui/core/Input'
import Typography from '@material-ui/core/Typography'
import 'styles/app/apps/user-assign.scss'
import { Button, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { connect } from 'react-redux'
import cn from 'classnames'
import { fetchSiteList } from 'reducers/logbookForm/reducer'
import Psfs from 'lib/psfs/Psfs'
import { ReactComponent as Bin } from 'assets/img/bin.svg'
import { fetchTaskAssignList } from 'reducers/jobTasksAdmin/reducer'
import CircleLoader from 'components/Loading/CircleLoader'
import { ReactComponent as Arrow } from 'assets/img/arrow-bottom.svg'
import { JOB_WORKFLOW_TASKS } from 'constants/appRouting'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import translate from './translate'
import RadioSelect from './RadioSelect'
import MultiSelect from './MultiSelect'

function ActionsColumn({
  siteId,
  title,
  message,
  userAssignInternalList,
  setUserAssignInternalList,
}) {
  const [dialog, setDialog] = useState(false)

  return (
    <td>
      <div
        onClick={() => {
          setDialog(true)
        }}
        className="icon-wrap">
        <Bin />
      </div>
      <ConfirmDialog
        open={dialog}
        title={title}
        className="confirm-action dialog-primary-custom"
        message={message}
        onConfirmAction={() => {
          setUserAssignInternalList([
            ...userAssignInternalList.filter(({ site }) => site?.id !== siteId),
          ])
          setDialog(false)
        }}
        onClose={() => setDialog(false)}
        cancel={{
          color: 'default',
          variant: 'outlined',
        }}
      />
    </td>
  )
}

// eslint-disable-next-line max-statements
function AssignUsersFormTable({
  intl: { formatMessage },
  setIsUserTableOpen,
  fetchSiteList,
  siteList,
  assignData,
  userAssignList,
  loading,
  fetchTaskAssignList,
  isUserTableOpen,
  userAssignInternalList,
  setUserAssignInternalList,
  id,
}) {
  const [filteredData, setFilteredData] = useState(userAssignInternalList)
  const [selectedSites, setSelectedSites] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const [anchorElUsers, setAnchorElUsers] = useState(null)
  const [newSelectedSites, setNewSelectedSites] = useState([])
  const [newSelectedUsers, setNewSelectedUsers] = useState([])
  const [isNewRowSelected, setIsNewRowSelected] = useState(false)
  const [isUpdated, setIsUpdated] = useState(false)
  const [isAssignListLoaded, setIsAssignListLoaded] = useState(false)
  const [clearAll, setClearAll] = useState(false)
  const [currentSite, setCurrentSite] = useState({})
  const userAssignPsfs = new Psfs(JOB_WORKFLOW_TASKS)
  const allSitesSite = {
    id: null,
    name: formatMessage(translate.allSites),
  }
  const normalizeSite = site =>
    site == null || site.id == null ? allSitesSite : site
  const sitesSelected = isNewRowSelected
    ? selectedSites.map(site => site?.id)
    : newSelectedSites.map(site => site?.id)
  const hasAllSitesAssignment = userAssignInternalList.some(
    ({ site }) => site == null || site.id == null,
  )
  const allSelectedSites = hasAllSitesAssignment
    ? (siteList || []).map(({ id }) => id).filter(id => id != null)
    : [
        ...userAssignInternalList
          .map(({ site }) => site?.id)
          .filter(
            id =>
              id != null &&
              !selectedSites.find(selectedSite => selectedSite?.id === id) &&
              id !== currentSite?.id,
          ),
        ...sitesSelected.filter(id => id != null),
      ]
  const [sortColumn, setSortColumn] = useState('')
  const [sortDirection, setSortDirection] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const isEmpty = searchValue

  useEffect(() => {
    const sitePsfs = {
      psfs: new Psfs(),
    }
    sitePsfs.psfs
      .addFilter('active', 1)
      .addFilter('visibleInUi', 1)
      .addFields(['id', 'name'])

    fetchSiteList({ ...sitePsfs })
  }, [])

  useEffect(() => {
    setNewSelectedUsers([])
    setNewSelectedSites([])
    setUserAssignInternalList(
      userAssignList.map(item => ({
        ...item,
        site: normalizeSite(item.site),
        users: item.users || [],
        userGroups: item.userGroups || [],
      })),
    )
  }, [JSON.stringify(userAssignList)])

  useEffect(() => {
    setSelectedSites(
      userAssignInternalList.length
        ? userAssignInternalList.map(data => normalizeSite(data.site))
        : [],
    )
  }, [userAssignInternalList])

  useEffect(() => {
    if (id && isUserTableOpen && !isAssignListLoaded) {
      setIsAssignListLoaded(true)
      fetchTaskAssignList({ psfs: userAssignPsfs, id })
    }
  }, [isUserTableOpen, isAssignListLoaded])

  useEffect(() => {
    if (!searchValue) {
      setFilteredData(userAssignInternalList)

      return
    }

    setFilteredData(
      userAssignInternalList.filter(({ site }) => {
        const normalized = normalizeSite(site)

        return (normalized.id == null
          ? formatMessage(translate.allSites)
          : normalized.name
        )
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      }),
    )
  }, [searchValue, userAssignInternalList])

  useEffect(() => {
    if (!sortColumn) {
      return
    }

    setFilteredData(
      filteredData.sort(({ site: prevSite }, { site: nextSite }) => {
        const prevNormalized = normalizeSite(prevSite)
        const nextNormalized = normalizeSite(nextSite)
        const prev =
          prevNormalized.id == null
            ? formatMessage(translate.allSites)
            : prevNormalized.name
        const next =
          nextNormalized.id == null
            ? formatMessage(translate.allSites)
            : nextNormalized.name

        if (prev > next) {
          return sortDirection ? 1 : -1
        }

        if (prev < next) {
          return sortDirection ? -1 : 1
        }

        return 0
      }),
    )
  }, [sortColumn, userAssignInternalList, sortDirection])

  const changeSortColumn = column => {
    const order = column === sortColumn ? !sortDirection : false

    setSortColumn(column)
    setSortDirection(order)
  }

  const handleSubmit = () => {
    if (!isUpdated) {
      setAnchorElUsers(null)
      setAnchorEl(null)

      return
    }

    const sites = isNewRowSelected ? newSelectedSites : selectedSites
    const users = isNewRowSelected ? newSelectedUsers : selectedUsers

    setAnchorElUsers(null)
    setAnchorEl(null)

    if (isNewRowSelected) {
      const list = []
      const hasAllSites = sites.some(site => site == null || site.id == null)
      const nextExisting = hasAllSites
        ? []
        : userAssignInternalList.filter(
            ({ site }) => site != null && site.id != null,
          )

      sites.forEach(site => {
        list.push({
          site: normalizeSite(site),
          users: users.filter(({ isUser }) => isUser),
          userGroups: users.filter(({ isUser }) => !isUser),
        })
      })

      setUserAssignInternalList([...nextExisting, ...list])
      setNewSelectedUsers([])
      setNewSelectedSites([])
    } else {
      setUserAssignInternalList([
        ...userAssignInternalList.filter(
          ({ site }) => site?.id !== currentSite?.id,
        ),
        {
          site: normalizeSite(sites[0]),
          users: users.filter(({ isUser }) => isUser),
          userGroups: users.filter(({ isUser }) => !isUser),
        },
      ])
    }
  }

  const openSites = (currentTarget, selectedSite, selectedUsers) => {
    setIsNewRowSelected(false)
    setIsUpdated(false)
    setAnchorEl(currentTarget)
    setSelectedUsers(selectedUsers)
    setSelectedSites([selectedSite])
    setCurrentSite(selectedSite)
  }

  const openUsers = (currentTarget, selectedSite, selectedUsers) => {
    setIsNewRowSelected(false)
    setIsUpdated(false)
    setAnchorElUsers(currentTarget)
    setSelectedUsers(selectedUsers)
    setSelectedSites([selectedSite])
    setCurrentSite(selectedSite)
  }

  const openNewSites = (currentTarget, selectedSites, selectedUsers) => {
    setIsNewRowSelected(true)
    setAnchorEl(currentTarget)
    setNewSelectedSites(selectedSites)
    setNewSelectedUsers(selectedUsers)
    setIsUpdated(false)
  }

  const openNewUsers = (currentTarget, selectedSites, selectedUsers) => {
    setIsNewRowSelected(true)
    setAnchorElUsers(currentTarget)
    setNewSelectedSites(selectedSites)
    setNewSelectedUsers(selectedUsers)
    setIsUpdated(false)
  }

  return (
    <div
      className={cn('user-assign-table-wrapper', { hidden: !isUserTableOpen })}>
      <div className="user-assign-header">
        <Typography variant="subtitle1" className="subtitle left-block">
          {formatMessage(translate.assignment)}
        </Typography>
        <IconButton
          className="close-btn"
          size="small"
          onClick={() => setIsUserTableOpen(false)}>
          <CloseIcon />
        </IconButton>
      </div>
      <div className="user-assign-search">
        <div className="left-block">
          <div className="search-block">
            <Input
              className="search-field"
              placeholder={formatMessage(translate.searchBySite)}
              onChange={({ target: { value } }) => setSearchValue(value)}
              value={searchValue}
              disableUnderline
            />
          </div>
        </div>
        <Button
          onClick={() => {
            if (!userAssignInternalList.length) {
              return
            }

            setClearAll(true)
          }}>
          <Typography className="user-assign-button primary">
            {formatMessage(translate.clearAll)}
          </Typography>
        </Button>
      </div>
      <table className="user-assign-table">
        <thead>
          <tr className="table-row">
            <th onClick={() => changeSortColumn('site')}>
              <div className="th-content">
                {formatMessage(translate.site)}
                {sortColumn === 'site' && (
                  <div className={cn({ arrow: sortDirection })}>
                    <Arrow />
                  </div>
                )}
              </div>
            </th>
            <th>{formatMessage(translate.assignee)}</th>
            <th className="col-small">{formatMessage(translate.actions)}</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map(({ site, userGroups = [], users = [] }) => {
            const normalizedSite = normalizeSite(site)

            return (
              <tr key={normalizedSite.id ?? 'all'}>
                <td
                  onClick={({ currentTarget }) =>
                    openSites(currentTarget, normalizedSite, [
                      ...users.map(user => ({ ...user, isUser: true })),
                      ...userGroups,
                    ])
                  }>
                  {normalizedSite.id == null
                    ? formatMessage(translate.allSites)
                    : normalizedSite.name}
                </td>
                <td
                  onClick={({ currentTarget }) =>
                    openUsers(currentTarget, normalizedSite, [
                      ...users.map(user => ({ ...user, isUser: true })),
                      ...userGroups,
                    ])
                  }>
                  {[...users, ...userGroups]
                    .map(({ name }) => ` ${name}`)
                    .toString()}
                </td>
                <ActionsColumn
                  siteId={normalizedSite.id}
                  userAssignPsfs={userAssignPsfs}
                  title={formatMessage(translate.deleteAssign)}
                  message={formatMessage(translate.deleteAssignMessage)}
                  userAssignInternalList={userAssignInternalList}
                  setUserAssignInternalList={setUserAssignInternalList}
                />
              </tr>
            )
          })}
          {!isEmpty && (
            <tr className="empty-row">
              <td
                className={cn({ 'empty-col-text': !newSelectedSites.length })}
                onClick={({ currentTarget }) =>
                  openNewSites(
                    currentTarget,
                    newSelectedSites,
                    newSelectedUsers,
                  )
                }>
                {newSelectedSites.length
                  ? newSelectedSites
                      .map(site => {
                        const normalized = normalizeSite(site)

                        return normalized.id == null
                          ? ` ${formatMessage(translate.allSites)}`
                          : ` ${normalized.name}`
                      })
                      .toString()
                  : formatMessage(translate.chooseSite)}
              </td>
              <td
                className={cn({ 'empty-col-text': !newSelectedUsers.length })}
                onClick={({ currentTarget }) =>
                  openNewUsers(
                    currentTarget,
                    newSelectedSites,
                    newSelectedUsers,
                  )
                }>
                {newSelectedUsers.length
                  ? newSelectedUsers.map(({ name }) => ` ${name}`).toString()
                  : formatMessage(translate.chooseAssignees)}
              </td>
              <td />
            </tr>
          )}
        </tbody>
      </table>
      <RadioSelect
        isOpen={!!anchorEl}
        disabled={!!searchValue || isNewRowSelected}
        options={siteList}
        selected={selectedSites}
        setSelected={value => {
          const update = isNewRowSelected
            ? setNewSelectedSites
            : setSelectedSites
          setIsUpdated(currentSite?.id !== value[0]?.id)
          update(value)
        }}
        buttonRef={anchorEl}
        allSelectedSites={allSelectedSites}
        handleClose={() => {
          if (
            (isNewRowSelected && newSelectedUsers.length) ||
            !isNewRowSelected
          ) {
            handleSubmit()

            if (!isNewRowSelected && !isUpdated) {
              setAnchorElUsers(null)
              setAnchorEl(null)
            }
          }

          if (isNewRowSelected && !newSelectedUsers.length) {
            setAnchorEl(null)
          }
        }}
      />
      <MultiSelect
        isOpen={!!anchorEl}
        disabled={!!searchValue || !isNewRowSelected}
        options={siteList}
        hasSelectAllOption
        isMultiple={isNewRowSelected}
        selected={newSelectedSites}
        setSelected={value => {
          setIsUpdated(!!value.length && currentSite?.id !== value[0]?.id)
          setNewSelectedSites(value)
        }}
        buttonRef={anchorEl}
        allSelectedSites={allSelectedSites}
        isSiteList
        handleClose={() => {
          if (newSelectedUsers.length) {
            handleSubmit()
          }

          if (!newSelectedUsers.length) {
            setAnchorEl(null)
          }
        }}
      />
      <MultiSelect
        isOpen={!!anchorElUsers}
        options={assignData}
        hasSelectAllOption
        selected={isNewRowSelected ? newSelectedUsers : selectedUsers}
        setSelected={value => {
          const update = isNewRowSelected
            ? setNewSelectedUsers
            : setSelectedUsers

          setIsUpdated(true)
          update(value)
        }}
        buttonRef={anchorElUsers}
        individualSelect
        handleClose={() => {
          if (
            (isNewRowSelected && newSelectedSites.length) ||
            !isNewRowSelected
          ) {
            handleSubmit()
          }

          if (isNewRowSelected && !newSelectedSites.length) {
            setAnchorElUsers(null)
          }
        }}
      />
      <CircleLoader loading={loading} />
      <ConfirmDialog
        open={clearAll}
        title={formatMessage(translate.clearAssignList)}
        className="confirm-action dialog-primary-custom"
        message={formatMessage(translate.clearAssignListMessage)}
        onConfirmAction={() => {
          setClearAll(false)
          setUserAssignInternalList([])
        }}
        onClose={() => setClearAll(false)}
        cancel={{
          color: 'default',
          variant: 'outlined',
        }}
      />
    </div>
  )
}

export default connect(
  state => ({
    siteList: state.getIn(['logbookForm', 'siteList']).toJS(),
    userAssignList: state.getIn(['jobTasksAdmin', 'userAssignList']).toJS(),
    loading: state.getIn(['jobTasksAdmin', 'userAssignListLoading']),
  }),
  {
    fetchSiteList,
    fetchTaskAssignList,
  },
)(injectIntl(AssignUsersFormTable))
